/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Role with a set of permissions that can be assigned to user
 * @export
 * @interface InternalApiRole
 */
export interface InternalApiRole {
    /**
     * 
     * @type {number}
     * @memberof InternalApiRole
     */
    id?: number;
}

/**
 * Check if a given object implements the InternalApiRole interface.
 */
export function instanceOfInternalApiRole(value: object): value is InternalApiRole {
    return true;
}

export function InternalApiRoleFromJSON(json: any): InternalApiRole {
    return InternalApiRoleFromJSONTyped(json, false);
}

export function InternalApiRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRole {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function InternalApiRoleToJSON(json: any): InternalApiRole {
    return InternalApiRoleToJSONTyped(json, false);
}

export function InternalApiRoleToJSONTyped(value?: InternalApiRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

